import is from '@sindresorhus/is';
import { z } from 'zod';

const positionSetupRunStatusSchema = z.enum(['ANALYSING', 'WAITING_FOR_ANSWERS', 'READY', 'FAILED', 'CANCELLED']);

export const positionSetupProgressLineSchema = z.object({
    text: z.string(),
});

export type PositionSetupProgressLine = z.infer<typeof positionSetupProgressLineSchema>;

export const positionSetupFactSchema = z.object({
    text: z.string(),
    certainty: z.string(),
});

export type PositionSetupFact = z.infer<typeof positionSetupFactSchema>;

export const positionSetupSliderSchema = z.object({
    min: z.number(),
    max: z.number(),
    step: z.number(),
    unit: z.string().nullish(),
    suggested: z.number().nullish(),
});

export type PositionSetupSlider = z.infer<typeof positionSetupSliderSchema>;

const positionSetupQuestionSchema = z.object({
    id: z.string(),
    text: z.string(),
    type: z.string(),
    options: z.string().array().default([]),
    slider: positionSetupSliderSchema.nullish(),
    why: z.string().nullish(),
});

export type PositionSetupQuestion = z.infer<typeof positionSetupQuestionSchema>;

export const positionSetupRunSchema = z.object({
    id: z.string(),
    positionAttachmentIds: z.string().array().default([]),
    status: positionSetupRunStatusSchema,
    failureReason: z.string().nullish(),
    progress: positionSetupProgressLineSchema.array().default([]),
    facts: positionSetupFactSchema.array().default([]),
    questions: positionSetupQuestionSchema.array().default([]),
});

export type PositionSetupRun = z.infer<typeof positionSetupRunSchema>;

const positionPlanRequestSchema = z.record(z.string(), z.unknown());

const parseJsonText = (value: unknown): unknown => {
    if (!is.string(value)) {
        return value;
    }

    try {
        return JSON.parse(value);
    } catch {
        return value;
    }
};

export const positionSetupPackageSchema = z.preprocess(
    parseJsonText,
    z.object({
        planRequest: positionPlanRequestSchema.nullable().default(null),
    }),
);

export type PositionSetupPackage = z.infer<typeof positionSetupPackageSchema>;

export type PositionSetupRunStartRequest = {
    readonly positionArchitectureId: string;
    readonly positionAttachmentIds: readonly string[];
    readonly language: string;
};

export type PositionSetupAnswerRequest = {
    readonly questionId: string;
    readonly values: readonly string[];
};
